<template>
  <div class="billingInfoTable">
    <div class="table-container">
      <vxe-grid
        border
        show-overflow
        resizable
        ref="settleAccountsRef"
        class="vxe-table-element"
        size="mini"
        align="center"
        :auto-resize="true"
        :data="tableData"
        :valid-config="{ autoPos: true, message: 'inline' }"
        height="150"
      >
        <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in tableColumnList"
          :key="index"
          :type="item.type"
          :fixed="item.fixed"
          :field="item.field"
          :title="item.title"
          :width="item.width"
          :sortable="item.sortable"
        >
        </vxe-table-column>
      </vxe-grid>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'BillingInfoTable',
    props: {
      fetchTableData: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        tableData: this.fetchTableData,
        tableColumnList: [
          {
            field: 'invoiceDate',
            title: '开票日期',
          },
          {
            field: 'invoiceAmount',
            title: '开票金额',
          },
          {
            field: 'taxAmount',
            title: '开票税额',
          },
          {
            field: 'excludedTaxAmount',
            title: '开票不含税额',
          },
          {
            field: 'invoicedApplicationNumber',
            title: '开票申请编号',
          },
          {
            field: 'goldenInvoiceNumber',
            title: '金税发票编号',
          },
        ],
      };
    },
  };
</script>

<style></style>
